import {
  REPORTS_INVOICES_PAGE_REQUEST,
  REPORTS_INVOICES_LIST_INVOICE_REQUEST,
  REPORTS_INVOICES_SET_LIST_INVOICE,
  REPORTS_INVOICES_CHANGE_DATE,
  REPORTS_INVOICES_CHANGE_OUTLET,
  REPORTS_INVOICES_CHANGE_STATUS,
  REPORTS_INVOICES_SET_OUTLETS,
  REPORTS_INVOICES_SET_HAS_MORE,
  REPORTS_INVOICES_ON_REACH_BOTTOM,
  REPORTS_INVOICES_SET_NEXT_CURSOR,
  REPORTS_INVOICES_ON_SEARCH,
} from './constants';

export function invoicesPageRequest() {
  return { type: REPORTS_INVOICES_PAGE_REQUEST, payload: {} };
}

export function listInvoiceRequest(searchValues, previousInvoices?) {
  return {
    type: REPORTS_INVOICES_LIST_INVOICE_REQUEST,
    payload: { searchValues, previousInvoices },
  };
}

export function setListInvoice(invoices) {
  return { type: REPORTS_INVOICES_SET_LIST_INVOICE, payload: { invoices } };
}

export function changeDateInvoices(searchValues) {
  return {
    type: REPORTS_INVOICES_CHANGE_DATE,
    payload: { searchValues },
  };
}

export function changeOutletInvoices(searchValues) {
  return {
    type: REPORTS_INVOICES_CHANGE_OUTLET,
    payload: { searchValues },
  };
}

export function changeStatusInvoices(searchValues) {
  return {
    type: REPORTS_INVOICES_CHANGE_STATUS,
    payload: { searchValues },
  };
}

export function setOutlets(outlets) {
  return { type: REPORTS_INVOICES_SET_OUTLETS, payload: { outlets } };
}

export function onReachBottom(searchValues, previousInvoices) {
  return {
    type: REPORTS_INVOICES_ON_REACH_BOTTOM,
    payload: { searchValues, previousInvoices },
  };
}

export function onSearch(searchValues) {
  return {
    type: REPORTS_INVOICES_ON_SEARCH,
    payload: { searchValues },
  };
}

export function setNextCursor(nextCursor) {
  return {
    type: REPORTS_INVOICES_SET_NEXT_CURSOR,
    payload: { nextCursor },
  };
}

export function setHasMore(hasMore) {
  return {
    type: REPORTS_INVOICES_SET_HAS_MORE,
    payload: { hasMore },
  };
}
